import { html } from "htm/preact";
import { hydrate } from "preact";
import LocaleSwitcher from "../components/LocaleSwitcher.js";
const el = document.getElementById("locale-switcher-island");
if (el) {
  const lang = el.dataset.lang;
  const locales = JSON.parse(document.getElementById("locales").innerHTML);
  const pages = JSON.parse(document.getElementById("pages").textContent);
  
  hydrate(html`<${LocaleSwitcher} lang=${lang} locales=${locales} pages=${pages} />`, el);
}
